<template>
  <b-tabs type="is-boxed" class="doc-details">
    <!-- Processing logs tab -->
    <b-tab-item label="Processing" icon="file-sync">
      <document-details-processing :doc="doc" />
    </b-tab-item>
    <!-- Details tab -->
    <b-tab-item label="Document info" icon="information">
      <document-details-info :doc="doc" />
    </b-tab-item>
    <!-- Extended data JSON viewer tab -->
    <b-tab-item label="Extended data" icon="script-text">
      <document-details-data :doc="doc" />
    </b-tab-item>
  </b-tabs>
</template>

<script>
  import { getLogs, getDocument } from '../api'
  import DocumentDetailsInfo from "./DocumentDetailsInfo"
  import DocumentDetailsData from "./DocumentDetailsData"
  import DocumentDetailsProcessing from "./DocumentDetailsProcessing"

  export default {
    name: "DocumentDetails",
    components: { DocumentDetailsData, DocumentDetailsInfo, DocumentDetailsProcessing },
    props: {
      doc: { type: Object, required: true }
    },
    mounted() {
      this.loadLogs()
      this.loadDetails()
    },
    methods: {
      async loadLogs () {
        if (this.doc.busyLoadingLogs || (this.doc.logs && this.doc.logs.length)) {
          return
        }

        this.doc.busyLoadingLogs = true
        try {
          this.doc.logs = await getLogs(this.doc.task_id) // eslint-disable-line
        } catch (e) {
          // eslint-disable-next-line
          this.doc.logs = [{
            _id: 'guwno',
            message: 'Failed loading logs.',  // show just this text instead of an error toast
            timestamp: ''
          }]
        }
        this.doc.busyLoadingLogs = false // eslint-disable-line
      },
      async loadDetails () {
        if (this.doc.busyLoadingDetails || this.doc.errorLoadingDetails === false) {
          return
        }

        this.doc.busyLoadingDetails = true
        try {
          const d = await getDocument(this.doc.cirrus_id)
          this.doc.errorLoadingDetails = false
          this.doc.data = d.data
          this.doc.title = d.title
          this.doc.thumbnail_url = d.thumbnail_url
          // TODO: etc...
        } catch (e) {
          this.doc.errorLoadingDetails = true
        }
        this.doc.busyLoadingDetails = false // eslint-disable-line
      }
    }
  }
</script>
